import SeoTranslation from '../../../../../RunPay/Admin/IServices/Models/Seo/SeoTranslation';

export default class SeoItemResponse  {
	Id: number = 0;
	PageUrl?: string = '';
	Translations: Array<SeoTranslation> = null;
	constructor(obj?: Partial<SeoItemResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}



// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/IServices/Models/Seo/SeoItemResponse.ts